import { render, staticRenderFns } from "./MarriageVerify.vue?vue&type=template&id=5b8ab786&"
import script from "./MarriageVerify.vue?vue&type=script&lang=js&"
export * from "./MarriageVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports